import axios from "axios";

const PREFIJO = "/api/TknCr/"

export default {
    obtenerToken(){
        return axios.get(`${PREFIJO}VmGnTkn?externo=FORMULARIOS%20WEB`);
    }
}